import { render } from "./ContractTemplates.vue?vue&type=template&id=304808f6"
import script from "./ContractTemplates.vue?vue&type=script&lang=js"
export * from "./ContractTemplates.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__